export default {"src":"/_next/static/media/img3.01c8d94a.svg","height":200,"width":258,"blurWidth":0,"blurHeight":0};